import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import DataTable from 'components/organisms/data-table'
import sellerTableColumns from './seller-table-columns'

const propTypes = {
  data           : PropTypes.array,
  pagination     : PropTypes.object,
  onFetchData    : PropTypes.func,
  isLoading      : PropTypes.bool,
  rowButtonProps : PropTypes.shape({
    buttonText       : PropTypes.string,
    buttonColour     : PropTypes.string,
    isButtonDisabled : PropTypes.func,
    onButtonClick    : PropTypes.func
  }),
  hiddenColumns: PropTypes.arrayOf(PropTypes.string)
}

const defaultProps = {
  isLoading      : false,
  rowButtonProps : {
    buttonText       : '',
    buttonColour     : '',
    isButtonDisabled : () => {},
    onButtonClick    : () => {}
  }
}

/**
 * Table to display specific Seller Inbound columns for receiving
 * @param {Array<Object>} data - array of seller_inbound objects
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Function} onFetchData - function that will call endpoint for data
 * @param {Boolean} isLoading - whether the table is currently loading data from the backend
 * @param {object} rowButtonProps - Button Props for row button
 * @param {array} hiddenColumns - Hide specific columns by id
 */

const SellerTable = ({
  data,
  pagination,
  onFetchData,
  rowButtonProps,
  hiddenColumns,
  isLoading
}) => {

  const { buttonText, buttonColour, isButtonDisabled, onButtonClick } = rowButtonProps

  const columns = useMemo(
    () => sellerTableColumns({
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    }),
    [
      buttonText,
      buttonColour,
      isButtonDisabled,
      onButtonClick
    ]
  )

  return (
    <DataTable
      data={ data }
      columns={ columns }
      pagination={ pagination }
      onFetchData={ onFetchData }
      isLoading={ isLoading }
      hiddenColumns={ hiddenColumns }
    />
  )
}

SellerTable.propTypes    = propTypes
SellerTable.defaultProps = defaultProps

export default SellerTable
